import { Flex, Image } from '@chakra-ui/react'

export const ImgSah: React.FC<{ entidade?: string, textoPersonalizado?: string, masc?: boolean, center?: boolean }> = ({
  children,
  entidade,
  textoPersonalizado,
  masc,
  center
}) => {
  return (
        <Flex alignItems={'center'} color={'var(--Azul)'} justifyContent={'center'}>
            <Image className='sah_Img' height={'20rem'} src='https://sigah.blob.core.windows.net/assets/NovaSAH.png' />
            <Flex flexDir={'column'}>
                {entidade && <h3>Você ainda não criou nenhum{masc ? '' : 'a'} {entidade}<br /> O que acha de criar {masc ? 'o primeiro' : 'a primeira'}, agora?</h3>}
                {textoPersonalizado && <h3 style={{ textAlign: center ? 'center' : undefined }}>{textoPersonalizado}</h3>}
                <Flex justifyContent={'center'} marginTop={'1rem'}>
                    {children}
                </Flex>
            </Flex>
        </Flex>
  )
}
